import ControllerBase from './../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';

export default class ControllerLoginForm extends ControllerBase {
	private readonly componentRefs = {
		passwordToggler: 'password-toggler',
	};

	constructor(element: HTMLElement) {
		super(element);
		this.observePasswordToggler();
	}

	private observePasswordToggler(): void {
		const passwordToggler = this.$references[this.componentRefs.passwordToggler] as HTMLButtonElement;

		passwordToggler &&
			fromEvent(passwordToggler, 'click').subscribe((event) => {
				event.preventDefault();
				const inputToObserve = passwordToggler.nextElementSibling as HTMLInputElement;

				const shouldShowPassword = inputToObserve.type === 'password';

				if (shouldShowPassword) {
					inputToObserve.type = 'text';
				} else {
					inputToObserve.type = 'password';
				}
			});
	}
}
